import { observer } from 'mobx-react-lite'
import { Button, IconButton, Typography } from 'shared/ui'
import { EstimatedResponseInfo } from 'pages/settings/pages/compliance/ui/EstimatedResponseInfo/EstimatedResponseInfo'
import { useCompliancePageContext } from 'pages/settings/pages/compliance/context'
import styles from './styles.module.scss'

export const SummaryInternational = observer(() => {
  const { internationalPageStore } = useCompliancePageContext()

  const {
    internationalRegulation,
    internationalDataStatus,
    openSummaryModal,
    goToBusinessInfo,
    hideRegistrationErrorsBanner,
  } = internationalPageStore

  if (!internationalRegulation?.businessData) return null
  if (!internationalRegulation?.addressData) return null

  return (
    <div className={styles.wrap} onClick={openSummaryModal}>
      <div className={styles.infoContainer}>
        <div className={styles.leftContent}>
          <Typography
            ariaLabel='AfterRegisterSection_header'
            variant='body-md-medium'
            marginBottom={'4px'}
          >
            {internationalRegulation.businessData.legalBusinessName}
          </Typography>
          <Typography
            ariaLabel='AfterRegisterSection_descLine1'
            variant='body-md-regular'
            color='var(--content-primary-tertiary)'
          >
            {internationalRegulation?.addressData.businessAddress}
          </Typography>
          <Typography
            ariaLabel='AfterRegisterSection_descLine1'
            variant='body-md-regular'
            color='var(--content-primary-tertiary)'
          >
            {internationalRegulation.secondLine}
          </Typography>
        </div>
        <div className={styles.rightContent}>
          {internationalRegulation.isStatusFailed && (
            <Button
              text='Update'
              onClick={(event) => {
                event.stopPropagation()
                goToBusinessInfo()
                hideRegistrationErrorsBanner()
              }}
            />
          )}
          <IconButton
            ariaLabel='AfterRegisterSection_buttonRight'
            icon={'chevronRight'}
            size={'small'}
            color='transparent'
          />
        </div>
      </div>
      <EstimatedResponseInfo iconData={internationalDataStatus} />
    </div>
  )
})
